import React from 'react';
import { Header, Plate, Text, WrapLabel } from './styled';
import Rating from './components/Raiting';
import MunicipalityStatistics from './components/MunicipalityStatistics';
import { Space } from '@gr-monorepo/common/ui';
import { ReactComponent as SertificatIcon } from './images/sertificate_icon.svg';
import InfoBlock from './components/InfoBlock';
import useUserData from 'hooks/useUserData';
import { Widget } from 'models/widgetMultiStageOlympiad';

const RegionalRating = ({
  isFirstFinished,
  isSecondFinished,
  isSecondStarted,
  widget,
}: {
  isFirstFinished: boolean;
  isSecondFinished: boolean;
  isSecondStarted: boolean;
  widget: Widget;
}) => {
  const userData = useUserData();
  const id = userData?.id || 0;

  const getRegionalRatingResultTitle = () => {
    if (isSecondFinished) {
      return `Итоговые результаты участия региона в олимпиаде \n ${widget.olympiadName}`;
    } else if (isFirstFinished) {
      return `Результаты участия региона в I туре олимпиады \n ${widget.olympiadName}`;
    }
    return `Статистика участия региона в I туре олимпиады \n ${widget.olympiadName}`;
  };

  return (
    <>
      <Plate>
        <WrapLabel>
          <SertificatIcon />
          <Text>{widget.orderTitle}</Text>
        </WrapLabel>
        <Space axis="vertical" size={14} />
        <Header>{getRegionalRatingResultTitle()}</Header>
        <Rating
          widget={widget}
          isFirstFinished={isFirstFinished}
          isSecondFinished={isSecondFinished}
          isSecondStarted={isSecondStarted}
        />

        {!isFirstFinished && !isSecondFinished && !isSecondStarted && (
          <MunicipalityStatistics id={id} widget={widget} />
        )}

        {!isSecondFinished && (isFirstFinished || isSecondStarted) && (
          <>
            <Space axis="vertical" size={40} />
            <InfoBlock isSecondStarted={isSecondStarted} cabmunId={id} widget={widget} />
          </>
        )}
      </Plate>
      <Space axis="vertical" size={40} />
    </>
  );
};

export default RegionalRating;
